import { Component, Inject, OnInit } from "@angular/core";
import { RfAuthenticationService } from "src/app/authentication/rf-authentication.service";
import { Profile } from "src/app/shared/service/store-management/model/profile";

import { BaseComponent } from "../../../base/base.component";
import { HierarchyManagementService } from "src/app/shared/service/store-management/hierarchy-management/hierarchy-management.service";
import { TitleWidgetComponent } from "../../../heading-widget/title-widget/title-widget.component";
import { MaterialModule } from "src/app/shared/module/material.module";
import { I18nPipe } from "src/app/shared/i18n/pipe/i18n.pipe";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "ald-profile-choose",
  templateUrl: "./profile-choose.component.html",
  styleUrls: ["./profile-choose.component.scss"],
  standalone: true,
  imports: [
    TitleWidgetComponent,
    MaterialModule,
    I18nPipe,
    FormsModule,
    CommonModule
  ]
})
export class ProfileChooseComponent extends BaseComponent implements OnInit {
  profiles;
  profileSelected = {} as Profile;
  roleSelected;
  roles = [];
  profileToReturn: Profile;
  closable = false;

  constructor(
    public dialogRef: MatDialogRef<ProfileChooseComponent>,
    public authService: RfAuthenticationService,
    private hierarchyManagementService: HierarchyManagementService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    super();
    this.dialogRef.disableClose = true;
  }

  onClose(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {
    const profiles = this.data.profiles;

    if (profiles.length === 1) {
      this.profileSelected = profiles[0].customerName;
      this.profileToReturn = profiles[0];
      this.roles = profiles[0].roles;
      this.roles.map((currentValue) => {
        if (currentValue.roleName === "myALD RICARICAR") {
          currentValue.roleName = "Ricaricar";
        }
        if (currentValue.roleName === "MyALD POST OFFICE") {
          currentValue.roleName = "Post Office";
        }
      });
    }
    this.profiles = profiles;
    this.closable = this.data.closable;
  }

  getCustomerName(profileSelected: Profile): string {
    return `${profileSelected?.customerReference} - ${profileSelected?.customerName} (${profileSelected?.firstName} ${profileSelected?.lastName})`;
  }

  getCustomerRef(): string {
    if (this.profiles.length === 1) {
      return `${this.profileToReturn?.firstName} ${this.profileToReturn?.lastName}`;
    }
  }
  getRoleRefRef(): any {
    console.log(this.profileToReturn.roles);
    return this.profileToReturn.roles.map((role) => role.roleName);
  }

  onSubmit(): void {
    console.log(this.profileToReturn);
    this.hierarchyManagementService.clearHierarchy();
    this.dialogRef.close(this.profileToReturn);
  }

  changeCustomerSelected(event): void {
    this.roles = [];
    this.roleSelected = null;
    this.profileToReturn = event.value;
    this.profileToReturn.customerName = event.value.customerName;
    this.roles = event.value.roles;
    this.roleSelected =
      event.value.roles.lenth === 1 ? event.value.roles[0] : null;
    console.log(this.roleSelected);
  }

  changeRoleSelected(event): void {
    this.profileToReturn.mappingMiles = event.value.mappingMiles;
    this.profileToReturn.role = event.value.roleId;
    this.profileToReturn.roleName = event.value.roleName;
  }

  onLogout(): void {
    this.authService.logout();
    this.dialogRef.close();
  }
}
